import { render, staticRenderFns } from "./CompanionDetailsModal.vue?vue&type=template&id=a66de3de"
import script from "./CompanionDetailsModal.vue?vue&type=script&lang=js"
export * from "./CompanionDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports